

























import { Component, Vue } from "vue-property-decorator";
import BottomNavigationComponent from "../bottom-navigation/bottom-navigation.vue";
import "./layout.css";

@Component({
  components: { BottomNavigationComponent }
})
export default class LayoutComponent extends Vue {
  get isMobile() {
    return this.$store.state.isMobile;
  }
   get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get showSectionLogout() {
    return this.$store.state.showSectionLogout;
  }
  get isQuickReference(){
    return !!this.$route.params.cedula;
  }
  get showNavbarInMobile() {
    return this.$store.state.showNavbarInMobile;
  }
  
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize);
    }
  }
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  }
  onResize() {
    this.$store.commit("setIsMobile", window.innerWidth < 1088);
  }
}
